// extracted by mini-css-extract-plugin
export default {"container":"SignUp_container__qRx4a","form":"SignUp_form__uSmXg","input":"SignUp_input__wSwgM","buttonContainer":"SignUp_buttonContainer__FfC8t","btn":"SignUp_btn__SFQm6"};